import BaseErrorPage from 'components/BaseErrorPage';
import useTitleOnMount from 'hooks/useTitleOnMount';

const NotFoundPage = () => {
  useTitleOnMount('Page Not Found');

  return (
    <BaseErrorPage title="Oops, we can’t find the page you were looking for">
      It looks like we may have moved the page, or it may not exist anymore
    </BaseErrorPage>
  );
};

export default NotFoundPage;
